module.exports = __webpack_public_path__ + "img/22200.9ef259ac.jpg";